import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  compose,
  setDisplayName,
  withHandlers,
  branch,
  renderNothing
} from "recompose";
import { actions } from "../modules/settings";
import { actions as dealerActions } from "../modules/dealers";
import { FormGroup } from "reactstrap";
import { isEmpty } from "lodash";
import RadioButton from "./RadioButton";

const mapStateToProps = state => ({
  role: state.settings.role,
  user: state.auth.user
});

const mapActionCreators = {
  setRole: actions.setRole,
  setCurrentDealer: dealerActions.setCurrentDealer
};

const propTypes = {
  role: PropTypes.string,
  setRole: PropTypes.func.isRequired,
  setCurrentDealer: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
};

const SelectRole = ({ role, onSelectRole, user }) => (
  <FormGroup>
    <h4>Select Role</h4>
    <RadioButton
      label="Staff Member"
      name="role"
      number="1"
      checked={role === "staff"}
      option="staff"
      onChange={onSelectRole}
    />
    <RadioButton
      label="Customer"
      name="role"
      number="2"
      checked={role === "customer"}
      option="customer"
      onChange={onSelectRole}
    />
  </FormGroup>
);

SelectRole.propTypes = propTypes;

export default compose(
  setDisplayName("SelectRole"),
  connect(
    mapStateToProps,
    mapActionCreators
  ),
  branch(
    ({ user }) => !(!isEmpty(user.staff) && !isEmpty(user.customers)),
    renderNothing
  ),
  withHandlers({
    onSelectRole: ({ setRole, setCurrentDealer }) => ev => {
      setRole(ev.target.value);
      setCurrentDealer(null);
    }
  })
)(SelectRole);
